import { useContext, useEffect, useState } from "react";
import { TextField } from '@mui/material';
import ColorPicker from 'react-best-gradient-color-picker';
import AuthContext from '../../../../store/AuthContext';
import BuilderContext from '../../../../store/BuilderContext';

const Color = (props) => {
  const { blockId, propertyName, screenType, name = "" } = props;
  const builderCtx = useContext(BuilderContext);
  const authCtx = useContext(AuthContext);
  const { contentBlocks, updateContentBlocks, currentContentBlock, updateCurrentBlock } = builderCtx;


  const getCurrentBlockStyles = () => {
    switch ( screenType ) {
      case "mobile" :
        return currentContentBlock?.mobileStyling;
      break;
      case "horizontal":
        return currentContentBlock?.horizontalStyling;
      break;
      case "vertical":
        return currentContentBlock?.verticalStyling;
      break;
      default:
        return currentContentBlock?.styling;
      break;
    }
  }

  const currentBlock = contentBlocks?.find(block => block.id === blockId);
  const currentBlockStyles = getCurrentBlockStyles()
  const currentColor = currentBlockStyles?.color || "#ffffff";

  const [bgColorHex, setBgColorHex] = useState(currentBlockStyles?.color || "#ffffff");
  const [finalValue, setFinalValue] = useState(currentBlockStyles?.color || "#ffffff");
  const [pickerOpen, setPickerOpen] = useState(false);
  const [color, setColor] = useState(currentBlockStyles?.color || "#ffffff");

  useEffect(() => {
    const timer = setTimeout(() => {
      setFinalValue(color);
    }, 200);
    return () => clearTimeout(timer);
  }, [color]);

  useEffect(() => {
    const lastFinalVal = currentColor || "#ffffff";
    if (finalValue !== lastFinalVal) {
      updateContentBlocks(prevBlocks => prevBlocks?.map(block => {
        if (block.id === blockId) {
          if (propertyName) {
            return { ...block, properties: { ...block.properties, [propertyName]: finalValue } };
          } else {
            const payload = {
              id: blockId,
              value: finalValue,
              screenType: screenType
            };

            fetch(process.env.REACT_APP_API_URI + '/v3/admin/assessment/styling/color', {
              method: 'PUT',
              mode: 'cors',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authCtx.token
              },
              body: JSON.stringify(payload)
            })
            .then(response => response.json())
            .then(data => {
              if (data.status === "success") {
              }
            }).catch((err) => {
              console.error("Failed to update color...", err);
            });

            switch (screenType) {
              case "mobile":
                return {
                  ...block,
                  mobileStyling: {
                    ...block.mobileStyling,
                    color: finalValue
                  }
                };
              case "horizontal":
                return {
                  ...block,
                  horizontalStyling: {
                    ...block.horizontalStyling,
                    color: finalValue
                  }
                };
              case "vertical":
                return {
                  ...block,
                  verticalStyling: {
                    ...block.verticalStyling,
                    color: finalValue
                  }
                };
              default:
                return {
                  ...block,
                  styling: {
                    ...block.styling,
                    color: finalValue
                  }
                };
            }
          }
        } else {
          return block;
        }
      }));
    }
  }, [authCtx.token, blockId, finalValue, propertyName, currentColor, screenType]);

  return (
    <div className="bgcolor tool">
      {props.deleteModal}
      <TextField
        className="bgcolor-input styling-input"
        type="text"
        variant="filled"
        InputLabelProps={{ shrink: true }}
        placeholder="Type in hex value or select color"
        value={finalValue}
        onChange={(e) => {
          setBgColorHex(e.target.value);
          setFinalValue(e.target.value);
        }}
      />
      <button style={{height:"45px",width:"10%",border:"1px solid #707070"}} type="color"
				className="color-box"
				value={finalValue}
				onClick={() => setPickerOpen(!pickerOpen)}>-</button>
			{pickerOpen && <ColorPicker className={'bg-color-picker'} value={finalValue} onChange={setFinalValue} />}
    </div>
  );
};

export default Color;
